/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../../redux/hooks'
import {showErrorMessage, showSuccessMessage} from '_metronic/helpers/swalHelper'
// import {verifyAccount} from '../../../../redux/Slice/parentSlice'

export function AccountVerification() {
  const {t} = useTranslation()
  const valSchema = Yup.object().shape({
    email: Yup.string()
      .required(t('VALIDATION.REQUIRED_', {name: t('PROFILE.EMAIL')}))
      .email(t('PROFILE.EMAIL_FORMAT')),
    verification_code: Yup.string().required(
      t('VALIDATION.REQUIRED_', {name: t('PARENT.VERIFICATION_CODE')})
    ),
  })
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()

  const formik = useFormik({
    initialValues: {email: '', verification_code: ''},
    validationSchema: valSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const formData = new FormData()
        formData.append('email', values.email)
        formData.append('verification_code', values.verification_code)

        // dispatch(verifyAccount(formData)).then((res: any) => {
        //   if (res.meta.requestStatus === 'fulfilled') {
        //     showSuccessMessage(t('PARENT.VERIFIED'), () => {})
        //   } else if (res.meta.requestStatus === 'rejected') {
        //     showErrorMessage(t('MESSAGES.' + res.payload.email))
        //   }

        //   setLoading(false)
        //   setSubmitting(false)
        // })
      } catch (error: any) {
        if (error.response) {
          if (error.response.status === 404) {
            setStatus(t('MESSAGES.NOT_FOUND_ERROR'))
          } else {
            setStatus(error.response.data.message)
          }
        } else if (error.request) {
        } else console.log('Error', error.message)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <div className='container-lg d-lg-flex justify-content-lg-center py-20 px-10'>
      <form className='form w-lg-50 shadow p-4' onSubmit={formik.handleSubmit} noValidate>
        <div className='text-center'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logo/umef-logo.png')} className='h-100px' />
          <h1 className='text-dark fw-bolder my-4'>{t('PARENT.ACCOUNT_VERIFICATION')}</h1>
        </div>

        <div className='fv-row mb-3'>
          <label className='form-label fs-6 fw-bolder text-dark py-2'>{t('PROFILE.EMAIL')}:</label>
          <input
            placeholder={t('PROFILE.EMAIL_PLACEHOLDER')}
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
            type='email'
            name='email'
            autoComplete='off'
          />
          {formik.touched.email && formik.errors.email && (
            <span className='text-danger fw-bold'>{formik.errors.email}</span>
          )}
        </div>

        <div className='fv-row mb-3'>
          <label className='form-label fs-6 fw-bolder text-dark py-2'>
            {t('PARENT.VERIFICATION_CODE')}:
          </label>
          <input
            placeholder={t('PARENT.VERIFICATION_PLACEHOLDER')}
            {...formik.getFieldProps('verification_code')}
            className={clsx(
              'form-control bg-transparent',
              {'is-invalid': formik.touched.verification_code && formik.errors.verification_code},
              {
                'is-valid': formik.touched.verification_code && !formik.errors.verification_code,
              }
            )}
            autoComplete='off'
          />
          {formik.touched.verification_code && formik.errors.verification_code && (
            <span className='text-danger fw-bold'>{formik.errors.verification_code}</span>
          )}
        </div>

        <div className='d-grid py-4'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary fw-bold'
            disabled={formik.isSubmitting || !formik.isValid || loading}
          >
            {!loading && <span className='indicator-label'>{t('PARENT.VERIFY')}</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                {t('GLOBAL.PLEASE_WAIT')}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </div>
  )
}
